<div class="star-container" [style.height]="containerHeight" [style.width]="containerWidth">
    <span class="background-star" [class.invisible]="fulness === 100" [class.unfilled]="hasBorder"></span>
    <span class="foreground-star" [style.width]="foregroundStarWidth"></span>
</div>
